export enum IconKey {
  // Sidebar
  SidebarDashboard = 'SidebarDashboard',
  SidebarMyFleet = 'SidebarMyFleet',
  SidebarFleetOverview = 'SidebarFleetOverview',
  SidebarMaintenanceAndInspections = 'SidebarMaintenanceAndInspections',
  SidebarMaintenanceAndInspectionsUpcoming = 'SidebarMaintenanceAndInspectionsUpcoming',
  SidebarMaintenanceAndInspectionsHistory = 'SidebarMaintenanceAndInspectionsHistory',
  SidebarExpand = 'SidebarExpand',
  SidebarCollapse = 'SidebarCollapse',
  SidebarReporting = 'SidebarReporting',
  SidebarReportingAvailable = 'SidebarReportingAvailable',
  SidebarReportingAutomatic = 'SidebarReportingAutomatic',
  SidebarNotifications = 'SidebarNotifications',
  SidebarTransfers = 'SidebarTransfers',
  SidebarAutomatedTransfersOnTheRoad = 'SidebarAutomatedTransfersOnTheRoad',
  SidebarAutomatedTransfersScheduled = 'SidebarAutomatedTransfersScheduled',
  SidebarAdministration = 'SidebarAdministration',
  SidebarAdministrationMaintenanceAndInspections = 'SidebarAdministrationMaintenanceAndInspections',
  SidebarAdministrationManagement = 'SidebarAdministrationManagement',

  // Topbar
  TopbarAutomatedTransferIndicator = 'TopbarAutomatedTransferIndicator',
  TopbarAttentionIndicator = 'TopbarAttentionIndicator',
  TopbarNotificationIndicator = 'TopbarNotificationIndicator',
  TopbarNotificationAcknowledge = 'TopbarNotificationAcknowledge',
  TopbarInfo = 'TopbarInfo',
  TopbarAppSwitcher = 'TopbarAppSwitcher',
  TopbarUserSwitcherAvatar = 'TopbarUserSwitcherAvatar',
  TopbarUserSwitcherDropdown = 'TopbarUserSwitcherDropdown',

  // Breadcrumb
  BreadcrumbHomeButton = 'BreadcrumbHomeButton',
  BreadcrumbBackButton = 'BreadcrumbBackButton',
  BreadcrumbHelpSwitch = 'BreadcrumbHelpSwitch',
  BreadcrumbHelpCloser = 'BreadcrumbHelpCloser',

  // Filters & Search Bar
  SearchBarAutocompleteSuggestionIndicator = 'SearchBarAutocompleteSuggestionIndicator',
  SearchBarClearer = 'SearchBarClearer',
  FilterColumnSelector = 'FilterColumnSelector',
  FilterColumnItemGrip = 'FilterColumnItemGrip',
  FilterColumnItemIndicator = 'FilterColumnIconIndicator',
  FilterSelector = 'FilterSelector',
  FilterClearer = 'FilterClearer',
  FilterOpen = 'FilterOpen',
  FilterClosed = 'FilterClosed',
  FilterActiveIndicator = 'FilterActiveIndicator',
  FilterToggle = 'FilterToggle',

  // Map
  MapLocationSearch = 'MapLocationSearch',
  MapLayerEquipment = 'MapLayerEquipment',
  MapLayerGeofence = 'MapLayerGeofence',
  MapLayers = 'MapLayers',
  MapQuickFilter = 'MapQuickFilter',
  MapAddGeofence = 'MapAddGeofence',
  MapStockGeofence = 'MapStockGeofence',
  MapProjectGeofence = 'MapProjectGeofence',
  MapGlobalGeofence = 'MapGlobalGeofence',
  MapDispositionGeofence = 'MapDispositionGeofence',
  MapAlarmGeofence = 'MapAlarmGeofence',
  MapEditGeofence = 'MapEditGeofence',
  MapDeleteGeofence = 'MapDeleteGeofence',
  MapShowAllGeofences = 'MapShowAllGeofences',
  MapInfoTelematicsEquipmentPosition = 'MapInfoTelematicsEquipmentPosiitond',
  MapClusterListItemJumpTo = 'MapClusterListItemJumpTo',
  MapZoomControlZoomIn = 'MapZoomControlZoomIn',
  MapZoomControlZoomOut = 'MapZoomControlZoomOut',
  MapTypeControlToggle = 'MapTypeControlToggle',
  MapInfoOrganisationItem = 'MapInfoOrganisationItem',
  MapInfoOrganisationOpenDetails = 'MapInfoOrganisationOpenDetails',
  MapInfoWindowClusterGlobalListGoBack = 'MapInfoWindowClusterGlobalListGoBack',

  // Reports
  ReportFormReset = 'ReportFormReset',
  ReportFormCancel = 'ReportFormCancel',
  ReportFormGenerate = 'ReportFormGenerate',
  ReportCreateAutomaticReport = 'ReportCreateAutomaticReport',
  ReportCardDefaultIcon = 'ReportCardDefaultIcon',

  // Equipment Header
  EquipmentHeaderTelematicStatusSending = 'EquipmentHeaderTelematicStatusSending',
  EquipmentHeaderTelematicStatusNoData = 'EquipmentHeaderTelematicStatusNoData',
  EquipmentHeaderReportNewDamage = 'EquipmentHeaderReportNewDamage',
  EquipmentHeaderBackToTitle = 'EquipmentHeaderBackToTitle',

  // Equipment Details
  EquipmentDetailsMapOpenInGoogleMaps = 'EquipmentDetailsMapOpenInGoogleMaps',
  EquipmentFavoriteIndicator = 'EquipmentFavoriteIndicator',
  EquipmentDetailsSelectOrgEdit = 'EquipmentDetailsSelectOrgEdit',
  EquipmentDetailsStatusTotalWorkingHours = 'EquipmentDetailsStatusTotalWorkingHours',
  EquipmentDetailsStatusTotalIdleHours = 'EquipmentDetailsStatusTotalIdleHours',
  EquipmentDetailsTableCellFaultDisplay = 'EquipmentDetailsTableCellFaultDisplay',

  // Equipment Activity Status
  ActivityStatusWorking = 'ActivityStatusWorking',
  ActivityStatusIdling = 'ActivityStatusIdling',
  ActivityStatusStopped = 'ActivityStatusStopped',
  ActivityStatusUnknown = 'ActivityStatusUnknown',

  // Equipment Attention Status
  AttentionStatusGood = 'AttentionStatusGood',
  AttentionStatusMachineFault = 'AttentionStatusMachineFault',
  AttentionStatusMaintenanceDue = 'AttentionStatusMaintenanceDue',
  AttentionStatusMachineFaultAndMaintenanceDue = 'AttentionStatusMachineFaultAndMaintenanceDue',

  // Equipment Events
  EquipmentEventsAddEvent = 'EquipmentEventsAddEvent',
  EquipmentEventsAddWizardStepTypes = 'EquipmentEventsAddWizardStepTypes',
  EquipmentEventsAddWizardStepDetails = 'EquipmentEventsAddWizardStepDetails',
  EquipmentEventsTypeIncident = 'EquipmentEventsTypeIncident',
  EquipmentEventsTypeOperatingHours = 'EquipmentEventsTypeOperatingHours',
  EquipmentEventsTypeMileage = 'EquipmentEventsTypeMileage',
  EquipmentEventsTypeDamage = 'EquipmentEventsTypeDamage',

  // Telematics
  TelematicsBatteryStatusHigh = 'TelematicsBatteryStatusHigh',
  TelematicsBatteryStatusLow = 'TelematicsBatteryStatusLow',
  TelematicsBatteryStatusCritical = 'TelematicsBatteryStatusCritical',
  TelematicsBatteryStatusUnknown = 'TelematicsBatteryStatusUnknown',
  TelematicsEngineStatusRunning = 'TelematicsEngineStatusRunning',
  TelematicsEngineStatusWarning = 'TelematicsEngineStatusWarning',

  // Global Icons (like save, delete, etc.)
  GlobalListSwitchToList = 'GlobalListSwitchToList',
  GlobalListSwitchToMap = 'GlobalListSwitchToMap',
  GlobalExport = 'GlobalExport',
  GlobalExportFast = 'GlobalExportFast',
  GlobalExportConfiguration = 'GlobalExportConfiguration',
  GlobalSearch = 'GlobalSearch',
  GlobalSettings = 'GlobalSettings',
  GlobalCreate = 'GlobalCreate',
  GlobalEdit = 'GlobalEdit',
  GlobalDelete = 'GlobalDelete',
  GlobalCancel = 'GlobalCancel',
  GlobalFormReset = 'GlobalFormReset',
  GlobalDefaults = 'GlobalDefaults',
  GlobalApply = 'GlobalApply',
  GlobalSave = 'GlobalSave',
  GlobalExclamation = 'GlobalExclamation',
  GlobalButtonSpinner = 'GlobalButtonSpinner',
  GlobalActions = 'GlobalActions',
  GlobalSort = 'GlobalSort',
  GlobalFormBack = 'GlobalFormBack',
  GlobalFormNext = 'GlobalFormNext',
  GlobalLinkTo = 'GlobalLinkTo',
  GlobalRefresh = 'GlobalRefresh',
  GlobalBan = 'GlobalBan',
  GlobalInfo = 'GlobalInfo',
  GlobalLegal = 'GlobalLegal',
  GlobalClose = 'GlobalClose',
  GlobalSortAsc = 'GlobalSortAsc',
  GlobalSortDesc = 'GlobalSortDesc',

  // UI Elements
  UIExpandableTableExpand = 'UIExpandableTableExpand',
  UIExpandableTableCollapse = 'UIExpandableTableCollapse',
  UITableSort = 'UITableSort',
  UITableSortUp = 'UITableSortUp',
  UITableSortDown = 'UITableSortDown',
  UITableLoading = 'UITableLoading',
  UITableSelectionActionDropdown = 'UITableSelectionActionDropdown',
  UISelectRemoveToken = 'UISelectRemoveToken',
  UISelectErase = 'UISelectErase',
  UIChipRemoveToken = 'UIChipRemoveToken',
  UITreeTableExpand = 'UITreeTableExpand',
  UITreeTableCollapse = 'UITreeTableCollapse',
  UIExpandedRow = 'UIExpandedRow',
  UIInputDisplayFalse = 'UIInputDisplayFalse',
  UIInputDisplayTrue = 'UIInputDisplayTrue',
  UIInputDisplayUnknown = 'UIInputDisplayUnknown',

  // Settings Icons
  SettingsTableViewNormal = 'SettingsTableViewNormal',
  SettingsTableViewCondensed = 'SettingsTableViewCondensed',

  // Help Icons
  HelpTip = 'HelpTip',
  HelpNote = 'HelpNote',
  HelpWarning = 'HelpWarning',

  // File Types
  FileTypePDF = 'FileTypePDF',
  FileTypeDOC = 'FileTypeDOC',
  FileTypeMSWORD = 'FileTypeMSWORD',
  FileTypePPT = 'FileTypePPT',
  FileTypeJPG = 'FileTypeJPG',
  FileTypeImage = 'FileTypeImage',
  FileTypeSVG = 'FileTypeSVG',
  FileTypePNG = 'FileTypePNG',
  FileTypeGIF = 'FileTypeGIF',
  FileTypeText = 'FileTypeText',
  FileTypeZIP = 'FileTypeZIP',
  FileTypeRAR = 'FileTypeRAR',
  FileTypeMP3 = 'FileTypeMP3',
  FileTypeAudio = 'FileTypeAudio',
  FileTypeMP4 = 'FileTypeMP4',
  FileTypeMOV = 'FileTypeMOV',
  FileTypeVideo = 'FileTypeVideo',
  FileTypeXML = 'FileTypeXML',
  FileTypeFile = 'FileTypeFile',
  FileTypeCSV = 'FileTypeCSV',
  FileTypeExcel = 'FileTypeExcel',

  // Dashboard Widget
  DashboardWidgetEdit = 'DashboardWidgetEdit',
  DashboardWidgetDelete = 'DashboardWidgetDelete',
  DashboardWidgetMove = 'DashboardWidgetMove',

  // Maintenace Categories
  MaintenanceCategoryReminder = 'MaintenanceCategoryReminder',
  MaintenanceCategoryCheck = 'MaintenanceCategoryCheck',
  MaintenanceCategoryCheckAndRepair = 'MaintenanceCategoryCheckAndRepair',
  MaintenanceCategoryStandalone = 'MaintenanceCategoryStandalone',

  // Maintenance Plan Assigned Equipment
  MaintenancePlanAssignedEquipment = 'MaintenancePlanAssignedEquipment',
  MaintenancePlanCreatePlan = 'MaintenancePlanCreatePlan',
  MaintenancePlanAssign = 'MaintenancePlanAssign',
  MaintenancePlanSelectPlans = 'MaintenancePlanSelectPlans',
  MaintenancePlanFillSelectPlans = 'MaintenancePlanFillSelectPlans',

  // Maintenance Plan Create Form
  MaintenancePlanCreateFormDescription = 'MaintenancePlanCreateFormDescription',
  InspectionPlanCreateFormDescription = 'InspectionPlanCreateFormDescription',
  MaintenancePlanCreateFormGeneralDataStep = 'MaintenancePlanCreateFormGeneralDataStep',
  MaintenancePlanCreateFormRulesStep = 'MaintenancePlanCreateFormRulesStep',
  MaintenancePlanRemoveRule = 'MaintenancePlanRemoveRule',
  MaintenancePlanRemoveCondition = 'MaintenancePlanRemoveCondition',

  // Complete Maintenance Task
  CompleteMaintenanceTaskCompletionInfo = 'CompleteMaintenanceTaskCompletionInfo',
  CompleteMaintenanceTaskAdditionalInfo = 'CompleteMaintenanceTaskAdditionalInfo',

  // Interval card
  TimeInterval = 'TimeInterval',
  SpecificDate = 'SpecificDate',
  MileageInterval = 'MileageInterval',
  OperatingHoursInterval = 'OperatingHoursInterval',

  // Attachments
  AttachmentsUpload = 'AttachmentsUpload',
  AttachmentsChooseFile = 'AttachmentsChooseFile',
  AttachmentsMarkAsDefaultImage = 'AttachmentsMarkAsDefaultImage',
  AttachmentsDefaultImage = 'AttachmentsDefaultImage',
  AttachmentsAddLink = 'AttachmentsAddLink',
  AttachmentsLink = 'AttachmentsLink',

  // Automated Transfers
  TransferPaused = 'TransferPaused',
  ScheduledTransferAccordionTogglerInactive = 'ScheduledTransferAccordionTogglerInactive',
  ScheduledTransferAccordionTogglerActive = 'ScheduledTransferAccordionTogglerActive',
  ScheduledTransferSliderIconProject = 'ScheduledTransferSliderIconProject',
  ScheduledTransferSliderIconStock = 'ScheduledTransferSliderIconStock',
  ScheduledTransferSliderIconRemainingTime = 'ScheduledTransferSliderIconRemainingTime',
  ScheduledTransferSortAsc = 'ScheduledTransferSortAsc',
  ScheduledTransferSortDesc = 'ScheduledTransferSortDesc',
  ScheduledTransferDeactivate = 'ScheduledTransferDeactivate',
  ScheduledTransferTransferNow = 'ScheduledTransferTransferNow',
  ScheduledTransferRestartThresholdTimer = 'ScheduledTransferRestartThresholdTimer',
  ScheduledTransferCancelTransfer = 'ScheduledTransferCancelTransfer',
  AutomatedTransferEquipment = 'AutomatedTransferEquipment',
  AutomatedTransferLocationSelect = 'AutomatedTransferLocationSelect',
  AutomatedTransferTransferSummary = 'AutomatedTransferTransferSummary',
  AutomatedTransferProject = 'AutomatedTransferProject',
  AutomatedTransferStock = 'AutomatedTransferStock',
  AutomatedTransferMapAddress = 'AutomatedTransferMapAddress',

  // Stock type
  StockTypePerson = 'StockTypePerson',
  StockTypeContainer = 'StockTypeContainer',
  StockTypePosition = 'StockTypePosition',
  StockTypeVehicle = 'StockTypeVehicle',
  StockTypeStock = 'StockTypeStock',
  StockTypeMain = 'StockTypeMain',

  // Equipment Employee Role
  EquipmentEmployeeRoleOwner = 'EquipmentEmployeeRoleOwner',
  EquipmentEmployeeRolePossessor = 'EquipmentEmployeeRolePossessor',
  EquipmentEmployeeRolePersonInCharge = 'EquipmentEmployeeRolePersonInCharge',
  EquipmentEmployeeRoleDriver = 'EquipmentEmployeeRoleDriver',
  EquipmentEmployeeRoleMaintenanceAssignee = 'EquipmentEmployeeRoleMaintenanceAssignee',

  // Contact type
  ContactTypeGeneric = 'ContactTypeGeneric',
  ContactTypeCompany = 'ContactTypeCompany',
  ContactTypeCoContractor = 'ContactTypeCoContractor',
  ContactTypeGravelPlant = 'ContactTypeGravelPlant',
  ContactTypeLandfill = 'ContactTypeLandfill',
  ContactTypeLocation = 'ContactTypeLocation',
  ContactTypeUnknown = 'ContactTypeUnknown',

  // Alarm type
  AlarmTypeOperatingHours = 'AlarmTypeOperatingHours',
  AlarmTypeOperatingHoursContract = 'AlarmTypeOperatingHoursContract',
  AlarmTypeTankFillLevel = 'AlarmTypeTankFillLevel',
  AlarmTypeTotalCosts = 'AlarmTypeTotalCosts',
  AlarmTypeDamageCosts = 'AlarmTypeDamageCosts',
  AlarmTypeRepairCosts = 'AlarmTypeRepairCosts',
  AlarmTypeGuarantee = 'AlarmTypeGuarantee',
  AlarmTypeFullServiceContractEnd = 'AlarmTypeFullServiceContractEnd',
  AlarmTypeLeasingServiceContractEnd = 'AlarmTypeLeasingServiceContractEnd',
  AlarmTypeGlobalGeofenceViolation = 'AlarmTypeGlobalGeofenceViolation',
  AlarmTypeTimefencing = 'AlarmTypeTimefencing',
  AlarmTypeTransportTaskCreation = 'AlarmTypeTransportTaskCreation',
  AlarmTypeTransportTaskReturned = 'AlarmTypeTransportTaskReturned',
  AlarmTypeNewDamageAdded = 'AlarmTypeNewDamageAdded',
  AlarmTypeInactiveTelematicsUnit = 'AlarmTypeInactiveTelematicsUnit',
  AlarmTypeBatteryVoltage = 'AlarmTypeBatteryVoltage',
  AlarmTypeDefTankLevel = 'AlarmTypeDefTankLevel',
  AlarmTypeTelematicsUnitBatteryStatus = 'AlarmTypeTelematicsUnitBatteryStatus',
  AlarmTypeFaults = 'AlarmTypeFaults',
  AlarmTypeGeofenceViolation = 'AlarmTypeGeofenceViolation',
  AlarmTypeTheftProtection = 'AlarmTypeTheftProtection',
  AlarmTypeFallback = 'AlarmTypeFallback',

  // Warning level
  WarningLevelOverdue = 'WarningLevelOverdue',
  WarningLevelHigh = 'WarningLevelHigh',
  WarningLevelMedium = 'WarningLevelMedium',
  WarningLevelLow = 'WarningLevelLow',

  // Equipment telematic unit
  EquipmentTelematicUnitDefault = 'EquipmentTelematicUnitDefault',

  // List Item Factory
  ListItemFactoryEquipment = 'ListItemFactoryEquipment',
  ListItemFactoryMaintenance = 'ListItemFactoryMaintenance',
  ListItemFactoryOrganisation = 'ListItemFactoryOrganisation',

  // Root toast
  RootToastError = 'RootToastError',
  RootToastSuccess = 'RootToastSuccess',
  RootToastWarn = 'RootToastWarn',
  RootToastNeutral = 'RootToastNeutral',

  // Positions
  PositionsTableCellCoordinates = 'PositionsTableCellCoordinates',

  // Notifications
  NotificationsFormAlarmType = 'NotificationsFormAlarmType',
  NotificationsFormAlarmDetails = 'NotificationsFormAlarmDetails',

  // Equipment Attention Status
  MigrationStatusSuccess = 'MigrationStatusSuccess',
  MigrationStatusFailure = 'MigrationStatusFailure',
}
